// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_in","advertCardHeader__actions":"c-a_io","advertCardHeader__bottomLabel":"c-a_ip"};